import OfferModel from 'models/OfferModel';

OffersStore.dispatchToken = MakeShiftEmployeeDispatcher.register(OffersStore.dispatchCallback);

OffersStore.offers = [];
OffersStore.allOffers = [];

OffersStore.setOffers = function (offers) {
  const len = offers.length;
  for (let i = 0; i < len; i++) {
    const offer = new OfferModel(offers[i]);
    OffersStore.add(offer);
  }
};

OffersStore.setAllOffers = function (offers) {
  const len = offers.length;
  OffersStore.allOffers = [];
  for (let i = 0; i < len; i++) {
    const offer = new OfferModel(offers[i]);
    OffersStore.allOffers.push(offer);
  }
};

OffersStore.getOffer = function (id) {
  return OffersStore.get(id);
};

OffersStore.getAllOfferedShifts = function (startDate, endDate, all) {
  if (Utils.isNotDefined(startDate)) {
    startDate = moment(Utils.getCurrentDate())
      .startOf('month')
      .format();
  }

  if (Utils.isNotDefined(endDate)) {
    endDate = moment(startDate)
      .endOf('month')
      .format();
  }

  let data = OffersStore.models;
  if (all) {
    data = OffersStore.allOffers;
  }
  const rtnData = [];
  data.map((obj) => {
    if (
      !Utils.isNotDefined(startDate)
      && !Utils.isNotDefined(endDate)
      && moment(obj.attributes.start_time)
        .tz(obj.attributes.time_zone)
        .isBetween(startDate, endDate)
    ) {
      rtnData.push(obj.present());
    }
  });

  rtnData.sort(
    (a, b) => parseFloat(moment(a.start_time).unix()) - parseFloat(moment(b.start_time).unix()),
  );

  return rtnData;
};

OffersStore.getAvailableShiftByID = function (id) {
  let data = {};
  if (!Utils.isNotDefined(this.models)) {
    const len = this.models.length;
    for (let i = 0; i < len; i++) {
      const d = this.models[i].present();
      if (parseInt(d.id, 10) === parseInt(id, 10)) {
        data = d;
        break;
      }
    }
  }
  return data;
};

OffersStore.updateAllOffer = function (offer) {
  const len = OffersStore.allOffers.length;
  for (let i = 0; i < len; i++) {
    if (offer.attributes.id == OffersStore.allOffers[i].attributes.id) {
      OffersStore.allOffers[i].set(offer.toJSON());
      break;
    }
  }
};

OffersStore.onOfferReplyHandler = function (collection, response) {
  const offer = OffersStore.get(collection.id);
  offer.attributes.available_shift_reply_id = response.data.available_shift_reply.id;
  offer.attributes.replied = true;
  OffersStore.updateAllOffer(offer);
  OffersStore.trigger('offer:reply:success', OffersStore.models, offer);
};

OffersStore.onOfferReplyError = function (collection, error) {
  // console.log(JSON.stringify(error));
  OffersStore.trigger('offer:reply:error', error);
};

OffersStore.onOfferCancelHandler = function (collection, response) {
  const offer = OffersStore.get(collection.id);
  offer.attributes.available_shift_reply_id = null;
  offer.attributes.replied = false;
  OffersStore.updateAllOffer(offer);
  OffersStore.trigger('offer:cancel:success', collection, response);
};

OffersStore.onOfferCancelError = function (collection, error) {
  // console.log(JSON.stringify(error));
  OffersStore.trigger('offer:cancel:error', error);
};
